import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ProviderTypeModel from "../../models/provider-type";

export default class ProviderTypeRepository extends BaseRepository {
  static modelClass = ProviderTypeModel;
  modelName = "provider-type";
}
